import {
  API_BASE_URL,
  parseIstatecResponse,
  parseValidationError,
  type IstatecResponse,
} from './apiConfig';

export type { IstatecResponse };

export interface SendOtpPayload {
  name: string;
  email: string;
  require_work_email?: boolean;
}

export interface ValidateOtpPayload {
  name: string;
  work_email: string;
  personal_email: string;
  company: string;
  phone_number: string;
  service_interested_in: string;
  message: string;
  otp: string;
}

/**
 * Step 1 — POST /send_otp_email_validation
 * For the Contact-Us flow the caller should pass `require_work_email: true`
 * so personal-provider domains are rejected before the OTP is generated.
 */
export async function sendOtp(payload: SendOtpPayload): Promise<IstatecResponse> {
  try {
    const res = await fetch(`${API_BASE_URL}/send_otp_email_validation`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (res.status === 422) return parseValidationError(res);
    return parseIstatecResponse(res);
  } catch {
    return {
      status: 'error',
      message: 'Network error. Please check your connection and try again.',
      status_code: 0,
      data: null,
      request_id: '',
    };
  }
}

/**
 * Step 2 — POST /validate_otp_and_send_email
 * OTP is verified against `work_email`. `personal_email` is metadata that is
 * forwarded to the admin inquiry email.
 */
export async function validateOtpAndSubmit(payload: ValidateOtpPayload): Promise<IstatecResponse> {
  try {
    const res = await fetch(`${API_BASE_URL}/validate_otp_and_send_email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (res.status === 422) return parseValidationError(res);
    return parseIstatecResponse(res);
  } catch {
    return {
      status: 'error',
      message: 'Network error. Please try again.',
      status_code: 0,
      data: null,
      request_id: '',
    };
  }
}
